import { useQuery } from "@tanstack/react-query";
import { auditApi, type AuditLogFilters } from "@/lib/api";
import { queryKeys } from "./keys";

export function useAuditLog(filters: AuditLogFilters) {
  return useQuery({
    queryKey: queryKeys.audit.list(filters),
    queryFn: () => auditApi.listAuditLog(filters),
    placeholderData: (previous) => previous,
  });
}
